var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Catalogs", {
    attrs: {
      title: "Маркетинговые источники",
      "create-text": "Новый",
      "fetch-data": _vm.fetchData,
      fields: _vm.fields,
      "route-create": "MarketingSourceAdd",
      "route-edit": "MarketingSourceEdit",
      "route-view": "MarketingSourceView",
      "route-path": "/marketing_sources",
      "can-edit": _vm.canEditMarketingSourceCatalogs()
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f7a0376c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f7a0376c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Catalogs/MarketingSources/MarketingSources.vue
// module id = null
// module chunks = 